const cardHeight = arr => {
    let el = arr.reduce((acc, act) => {
        let count = 0;
        count = !!act.licenceType ? count+1:count;
        count = !!act.icon ? count+1:count;
        return count > acc ? count : acc;
    }, 0);
    return el;
};

export default cardHeight;